import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { serviceWorkerRegistrieren } from "./lib/push";
import { registerGlobalErrorHandlers } from "./reportError";
import { routeTree } from "./routeTree.gen";
import "./theme.css";

registerGlobalErrorHandlers({ target: window });

// Der Service Worker (Web Push, CHAT-AUFTRAG.md Stufe 3) — nur registrieren,
// kein Cache: Die App bleibt die frische vom Server.
void serviceWorkerRegistrieren();

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// Eine 401 zu wiederholen bringt nichts — die Antwort ändert sich
			// nicht dadurch, dass man sie nochmal holt. Der Guard leitet um.
			retry: (versuche, fehler) =>
				fehler instanceof Error && fehler.message.includes("401") ? false : versuche < 2,
		},
	},
});

/**
 * Der QueryClient geht als Router-Context hinein. Damit liest der Guard in
 * `_angemeldet.tsx` dieselbe Sitzung wie die Oberfläche und nicht eine
 * zweite, eigene.
 */
const router = createRouter({
	routeTree,
	context: { queryClient },
	// Beim Überfahren eines Links schon laden. Bei einer geschützten Route
	// heißt das auch: Der Guard läuft früher und die Umleitung kommt ohne
	// sichtbares Zögern.
	defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const container = document.getElementById("root");

if (container === null) {
	throw new Error("Kein Element mit der Id 'root' im Dokument gefunden.");
}

createRoot(container).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
		</QueryClientProvider>
	</StrictMode>,
);
